import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TemplateElementComponent } from '../template-element.component';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-template-card',
  templateUrl: './template-card.component.html',
  styleUrls: ['./template-card.component.scss', '../../../global-workspace-styles.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, MatButtonModule, RouterModule, MatTooltipModule, CommonModule]
})
export class TemplateCardComponent extends TemplateElementComponent {}
